<template>
    <div>
        <pagamento-detalhar :pagamento="pagamento">
            <template slot="footer" slot-scope="data">
                <app-btn-voltar></app-btn-voltar>
                <historico
                    class="ml-2"
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                ></historico>
                <pagamento-enviar-para-analise
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-2"
                ></pagamento-enviar-para-analise>
                <pagamento-aprovar-reprovar
                    :pagamento="pagamento"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                ></pagamento-aprovar-reprovar>
                <b-button
                    variant="primary"
                    class="ml-2"
                    @click.stop="mostrarAnexos = true"
                    v-if="$temAcessoView('APPSE-PAG-ANX-00') && !mostrarAnexos"
                    ><i class="fa fa-paperclip"></i> Documentos</b-button
                >
                <!-- <btn-exportar
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    class="ml-1"
                ></btn-exportar> -->
                <slot name="finalizacaoFooter" v-bind="data"></slot>
            </template>
        </pagamento-detalhar>
        <pagamento-anexos2
            v-if="$temAcessoView('APPSE-PAG-ANX-00') && mostrarAnexos"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @fechar="mostrarAnexos = false"
        ></pagamento-anexos2>
        <consultorias :consultorias="pagamento.consultorias">
            <template slot="botoes">
                <slot name="consultoriasBotoes"></slot>
            </template>
            <template slot="consultoriaAcoes" slot-scope="data">
                <slot name="consultoriaAcoes" v-bind="data"></slot>
                <pagamento-desassociar-consultoria
                    :pagamento="pagamento"
                    :pagamentoConsultoria="data"
                    :pagamentosServicos="pagamentosServicos"
                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                    class="ml-1"
                    v-if="mostrarBtnDesassociarConsultorias"
                ></pagamento-desassociar-consultoria>
            </template>
        </consultorias>
        <pagamento-anexos
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></pagamento-anexos>
    </div>
</template>

<script>
import PagamentoDetalhar from './PagamentoDetalhar'
import Consultorias from '../consultorias/Consultorias2'
import PagamentoAnexos from './PagamentoAnexos'
import PagamentoAnexos2 from './PagamentoAnexos2'
import { pagamentoStatus } from './PagamentoStatus'
import PagamentoDesassociarConsultoria from './PagamentoDesassociarConsultoria'
import PagamentoEnviarParaAnalise from './PagamentoEnviarParaAnalise'
import PagamentoAprovarReprovar from './PagamentoAprovarReprovar'
import Historico from './PagamentoHistorico'
// import BtnExportar from './BtnExportar'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            mostrarAnexos: false
        }
    },

    methods: {
        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        }
    },

    computed: {
        mostrarBtnDesassociarConsultorias() {
            return (
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.$temAcesso('APPSE-FORN-PAG-03')
            )
        }
    },

    components: {
        PagamentoDetalhar,
        Consultorias,
        PagamentoAnexos,
        PagamentoAnexos2,
        PagamentoDesassociarConsultoria,
        PagamentoEnviarParaAnalise,
        PagamentoAprovarReprovar,
        Historico
    }
}
</script>
